mod.modules.define("BaseDrawer", function(fn) {

	fn.prototype.dockSize = 15;
	fn.prototype._dockSide = ""; // "left" or "right"
	fn.prototype._dockSpeed = 100;
	fn.prototype._dockOpenDelay = 250;
	fn.prototype._dockOpenTimeout = null;
	fn.prototype.preventDocking = false;
	fn.prototype.isHoveredOver = false;

	fn.prototype._useOverlay = false;
	fn.prototype._overlaySpeed = 100;
	fn.prototype._overlay = null;

	fn.prototype._isPushy = false;
	fn.prototype._pushee = null;

	fn.prototype.onDock = function() { };
	fn.prototype.onUndock = function() { };

	fn.prototype.init = function(params) {
		// Pull the dock side from an attribute
		this._dockSide = this.el.attr("data-dockSide");

		// Position the drawer in the docked position
		this.el.css(this._dockSide, this._getDockPosition());

		// Determine whether or not we'll push adjacent content over
		this._isPushy = this.el.hasClass("drawer-pushy");
		this._useOverlay = this._isPushy;

		if (this._isPushy) {
			this._pushee = this.el.closest("div.section").find("div.drawer-pushable");
		}

		if (this._useOverlay) {
			this._overlay = this._getOverlay();
		}
	};

	fn.prototype.isDocked = function() {
		return this.el.hasClass("docked");
	};

	fn.prototype._getDockPosition = function() {
		return this.el.outerWidth() * -1 + this.dockSize;
	};

	fn.prototype.action_dock = function() {
		var el = this.el;

		// Move the drawer
		this._shift(
			this.el,
			this._getDockPosition(),
			function() {
				el.addClass("docked");
			}
		);

		// Move the content
		if (this._isPushy) {
			this._shift(this._pushee, 0);
		}

		if (this._useOverlay) {
			this._overlay.fadeOut(this._overlaySpeed);
		}

		if (this.onDock) {
			this.onDock();
		}
	};

	fn.prototype.action_unDock = function() {
		var fnUndock = function() {
			var el = this.el;

			// Move the drawer
			this._shift(
				this.el,
				0,
				function() {
					el.removeClass("docked");
				}
			);

			// Move the content
			if (this._isPushy) {
				this._shift(this._pushee, this._getDockPosition() * -1);
			}

			if (this._useOverlay) {
				this._overlay.css('filter', 'alpha(opacity=50)');
				this._overlay.fadeIn(this._overlaySpeed);
			}
		}

		// Wait a little bit before opening the dock
		this._dockOpenTimeout = setTimeout(
			$.proxy(fnUndock, this),
			this._dockOpenDelay
		);

		if (this.onUndock) {
			this.onUndock();
		}
	};

	// Does the heavy lifting of animating objects around
	fn.prototype._shift = function(el, distance, callback) {
		var params = {};
		params[this._dockSide] = distance;

		el.stop().animate(
			params,
			this._dockSpeed,
			callback || function() { }
		);
	};

	fn.prototype._getOverlay = function() {
		var section = this.el.closest("div.section");
		var overlay = section.find("div.overlay");

		if (!overlay.length) {
			overlay = $("<div class='overlay' />")
				.width(section.width())
				.hide();
			section.append(overlay);
		}

		return overlay;
	};

	fn.prototype.events = {
		"this": {
			mouseenter: function(e, $el) {
				this.isHoveredOver = true;

				if (this.isDocked() && !this.preventDocking) {
					this.action_unDock();
				}
			},
			mouseleave: function(e, $el) {
				this.isHoveredOver = false;

				if (!this.isDocked() && !this.preventDocking) {
					this.action_dock();
				}

				// Clear any timeout that's waiting to open the drawer
				window.clearTimeout(this._dockOpenTimeout);
			}
		}
	};

});